module.exports = __webpack_public_path__ + "img/headPic.b467e544.png";